const d3 = require('d3')

const apiClient = require('../graphql/apiClient')
const { formattedDescriptionFromResponse, titleCase } = require('../utils/formattingUtils')

const _ = {
  map: require('lodash/map'),
  find: require('lodash/find'),
}

const { gql } = require('graphql-tag')

const BLIPS_FRAGMENT = gql`
  fragment blipFields on Blip {
    id
    name
    description
    link
    quadrant {
      id
      name
    }
    labels
    status
    fixVersions
    slackChannel
    sponsor
    champions {
      name
      email
    }
    stewards {
      name
      email
    }
    history {
      publicationName
      movement
      status
    }
    readingMaterials
    relatedBlips {
      id
      name
      link
    }
    comments {
      author {
        name
        email
      }
      body
      created
      updated
    }
    thoughtworksBlipArchive
    githubRepo
    factSheets {
      id
      link
    }
    created
    updated
  }
`

const LATEST_BLIPS_QUERY = gql`
  ${BLIPS_FRAGMENT}

  query latestBlips($released: Boolean, $first: Int) {
    blips {
      ...blipFields
    }

    latestFixVersion: fixVersions(released: $released, first: $first) {
      name
    }
  }
`

const PUBLICATION_BLIPS_QUERY = gql`
  ${BLIPS_FRAGMENT}

  query publishedVolume($publicationName: ID) {
    publications(name: $publicationName) {
      name
      blips {
        ...blipFields
      }
    }
  }
`

const InputSanitizer = require('../../util/inputSanitizer')

const WorldKinectRadar = function () {
  var self = {}

  self.getPublicationBlips = function (publicationName) {
    return new Promise((resolve, reject) => {
      try {
        apiClient(PUBLICATION_BLIPS_QUERY, {
          publicationName: publicationName,
        })
          .then((res) => res.json())
          .then((result) => {
            return _.map(result.data.publications[0].blips, function (blip) {
              return convertAPIBlip(blip, publicationName)
            })
          })
          .then((blips) => {
            var sanitizedBlips = _.map(blips, new InputSanitizer().sanitize)

            resolve({
              title: publicationName,
              blips: sanitizedBlips,
            })
          })
      } catch (error) {
        reject(error)
      }
    }).catch((errors) => {
      console.error(errors)
      plotErrorMessage(errors)
    })
  }

  self.getLatestBlips = function () {
    return new Promise((resolve, reject) => {
      try {
        let latestFixVersion

        apiClient(LATEST_BLIPS_QUERY, {
          released: false,
          first: 1,
        })
          .then((res) => res.json())
          .then((result) => {
            latestFixVersion = result.data.latestFixVersion[0].name

            return _.map(result.data.blips, function (blip) {
              return convertAPIBlip(blip, 'latest')
            })
          })
          .then((blips) => {
            var sanitizedBlips = _.map(blips, new InputSanitizer().sanitize)
            resolve({
              title: latestFixVersion,
              blips: sanitizedBlips,
            })
          })
      } catch (error) {
        reject(error)
      }
    }).catch((errors) => {
      console.error(errors)
      plotErrorMessage(errors)
    })
  }

  self.init = function () {
    plotLoading()
    return self
  }

  return self
}

function convertAPIBlip(blip, publicationName) {
  return {
    name: blip.name,
    description: formattedDescriptionFromResponse(blip),
    isNew: _.find(blip.history, { publicationName: publicationName }).movement === 'NEW',
    ring: titleCase(blip.status),
    quadrant: blip.quadrant.name,
    labels: blip.labels,
    hasMovedIn: _.find(blip.history, { publicationName: publicationName }).movement === 'MOVED_IN',
    hasMovedOut: _.find(blip.history, { publicationName: publicationName }).movement === 'MOVED_OUT',
  }
}

function plotLoading() {
  document.querySelector('.helper-description .loader-text').style.display = 'block';
}

function plotErrorMessage(exception, fileType) {
  showErrorMessage(exception, fileType);
}

function showErrorMessage(exception, fileType) {
  document.querySelector('.helper-description .loader-text').style.display = 'none'
  const container = d3.select('main').append('div').attr('class', 'error-container')
  plotError(exception, container, fileType)
}

function plotError(exception, container, fileType) {
  let message = `🤯 Oops! It seems like there are some problems with loading your data`
  if (exception instanceof MalformedDataError) {
    message = message.concat(exception.message)
  } else if (exception instanceof SheetNotFoundError) {
    message = exception.message
  } else {
    console.error(exception)
  }
  container = container.append('div').attr('class', 'error-container')
  const errorContainer = container.append('div').attr('class', 'error-container__message')
  errorContainer.append('div').append('p').html(message)

  let homePageURL = window.location.protocol + '//' + window.location.hostname
  homePageURL += window.location.port === '' ? '' : ':' + window.location.port
  const homePage = '<a href=' + homePageURL + '>GO BACK</a>'

  errorContainer.append('div').append('p').html(homePage)
}

module.exports = WorldKinectRadar
